import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-plus" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "typo__label default" }, "Rechercher un Patient", -1)
const _hoisted_3 = {
  key: 0,
  class: "w-100 d-block d-md-flex align-items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "pb-2 mt-4 default" }, "Informations sur le patient selectionné: ", -1)
const _hoisted_6 = { class: "container default" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user text-secondary mx-1" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-book text-secondary mx-1" }, null, -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-address-book text-secondary mx-1" }, null, -1)
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_22 = { class: "row border-bottom-dashed" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person text-secondary mx-1" }, null, -1)
const _hoisted_25 = { class: "col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-calendar-days text-secondary mx-1" }, null, -1)
const _hoisted_27 = { class: "d-flex justify-content-center mt-4" }

import Modal from '@/views/Admin/Teleconsultation/Modal.vue';
import VueMultiselect from 'vue-multiselect'
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'

    const datas = "user,dossier";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'PatientSelect',
  props: {
        btn_text: {
            type: String,
            default: 'button'
        },
        routeName: {
            type: String,
            default: ''
        }
    },
  setup(__props) {

const props = __props

    const store = useStore();
    const router = useRouter();
    const modalVisible = ref(false);
    const find = ref([]);
    const searchData: [] | any = ref([])
    const patientSelect = ref(false)
    const isLoading = ref(false);
    function gotoTeleconsultationForm() {
        modalVisible.value = false;
        // router.push({ name: 'create-bulletin-examen'});
        window.location.href = props.routeName;
    }

    const DataPatient = (find: "") => {
        isLoading.value = true;
        store.dispatch('patient/searchPatient', find);
        searchData.value = store.state.patient.patient;
        isLoading.value = false;
    }

    function SelectPatient(id: 0, associations: "") {
        store.dispatch('patient/fetchPatient', { id: id, associations: associations }).then(() => {
            gotoTeleconsultationForm()
        })
    }

    const confirmPatient = (patient: "") => {
        patientSelect.value = true
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (modalVisible.value = true)),
      type: "button",
      class: "btn btn-primary p-2 fw-bold teleconsultation-btn"
    }, [
      _hoisted_1,
      _createTextVNode(" " + _toDisplayString(__props.btn_text), 1)
    ]),
    _createVNode(Modal, {
      modelValue: modalVisible.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalVisible).value = $event)),
      title: "Sélectionner un patient",
      bgcolor: "#172b4d",
      colorTitle: "white",
      notification: "true",
      width: "lg"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", null, [
            _hoisted_2,
            datas
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_unref(VueMultiselect), {
                    modelValue: find.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((find).value = $event)),
                    options: searchData.value,
                    "preserve-search": true,
                    onSearchChange: DataPatient,
                    onSelect: _cache[2] || (_cache[2] = ($event: any) => (confirmPatient(find.value))),
                    placeholder: "Rechercher un Patient",
                    label: "name",
                    "preselect-first": false
                  }, null, 8, ["modelValue", "options"])
                ]))
              : _createCommentVNode("", true),
            (find.value.user_id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", null, [
                          _hoisted_9,
                          _createTextVNode("Nom: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.nom), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", null, [
                          _hoisted_12,
                          _createTextVNode("Prenom: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.prenom), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", null, [
                          _hoisted_15,
                          _createTextVNode("Adresse: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.user_id), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", null, [
                          _hoisted_18,
                          _createTextVNode("Téléphone: "),
                          _createElementVNode("a", {
                            href: "#",
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OpenPhoneLink(find.value.telephone)))
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(find.value.telephone), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("p", null, [
                          _hoisted_21,
                          _createTextVNode("Date de Naissance: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.date_de_naissance), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("p", null, [
                          _hoisted_24,
                          _createTextVNode("Sexe: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.sexe), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("p", null, [
                          _hoisted_26,
                          _createTextVNode(" Age: "),
                          _createElementVNode("strong", null, _toDisplayString(find.value.age), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (SelectPatient(find.value.user_id, datas), (patientSelect.value = true))),
                        class: "btn btn-secondary py-2 shadow"
                      }, " Continuer vers le formulaire ")
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})